export const checkImage = path =>
new Promise((resolve,reject) => {
  const img = new Image();
  img.onload = () => resolve({path, status: 'ok'});
  img.onerror = () => reject(new Error("img load error"));

  img.src = path;
});